import styles from './css-modules/events.module.css';
import { useEffect } from 'react';
import {useLocation, Link, useNavigate} from 'react-router-dom';

function Events({ events }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state && location.state._key && location.state._type) {
          if (location.state._type === 'event') {
            navigate('event/' + location.state._key, {
              state: { background: location },
            });
          }
        }
    }, []);

    return (
      <div className={'section'}>
          <h2>Events</h2>
          <div className={styles.flexed_projects}>
            {events.length > 0 && events.map((event, index) => {
                return <div key={'events_' + index} className={styles.container}>
                    <div className={styles.image_container}>
                        <img src={event.eventInformation.image.sourceUrl} className={styles.title_image}></img>
                        <p className={styles.etype}>{event.eventInformation.type}</p>
                    </div>
                    <div className={styles.content_container}>
                        <h3 className={styles.title}>{event.title}</h3>
                        <p dangerouslySetInnerHTML={{__html: event.eventInformation.venue.replace('\n', '<br/>')}} className={styles.venue}></p>
                        
                        <div className={styles.buttons_container}>
                            <Link to={"event/" + event.id} state={{ background: location }} className={'button'}>
                                <div className={'button_animator'}>
                                    <div className={'button_animator_inner'}></div>
                                </div>
                                <p className={'button_text'}>Read More</p>
                            </Link> 
                            {event.eventInformation.registrationLink && <a href={event.eventInformation.registrationLink} target="_blank" className={'button left_margined_button different_color'}>
                                <div className={'button_animator'}>
                                    <div className={'button_animator_inner'}></div>
                                </div>
                                <p className={'button_text'}>Register</p>
                            </a> }
                        </div>
                    </div>  
                </div>
            })}
          </div>
      </div>
    );
  }
  
  export default Events;